// Code generated by protoc-gen-ts. DO NOT EDIT.
// protoc-gen-ts is an Art Processors production, found in mos-sdk-py.

import { PlacedPoint } from "generated/mos/geo";
import { Amenity, Rectangle, VisitorInfoPage, VisitorInfoSiteContent } from "generated/mos/org/getty/visitorinfo";
import { TranslatableStringValue } from "generated/mos/translatable";
import { Codec, DecodeContext, FieldMask, RemoteObject, WebRPCError, ensureScalar, stripTypePropertyDeep } from "generated/webrpc";

export namespace CreateAmenityRequest {
  export const refName = "mos.org.getty.visitor_info_management.CreateAmenityRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly amenityCategoryRef: { readonly typename: 'mos.org.getty.visitor_info.VisitorInfoPage', readonly id: string } | undefined,
    readonly name: TranslatableStringValue.Entity | undefined,
    readonly headerImageRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
    readonly headerImageAltText: TranslatableStringValue.Entity | undefined,
    readonly openingHoursText: TranslatableStringValue.Entity | undefined,
    readonly descriptionText: TranslatableStringValue.Entity | undefined,
    readonly locationText: TranslatableStringValue.Entity | undefined,
    readonly mapPdfRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
    readonly defaultMapZoomFrame: Rectangle.Entity | undefined,
    readonly mapAltText: TranslatableStringValue.Entity | undefined,
    readonly location: PlacedPoint.Entity | undefined,
    readonly wayfindingMapRef: { readonly typename: 'mos.org.getty.audio.WayfindingMap', readonly id: string } | undefined,
    readonly extendedDescriptionText: TranslatableStringValue.Entity | undefined,
    readonly iconImageRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
    readonly iconSelectedImageRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    amenityCategoryRef: undefined,
    name: undefined,
    headerImageRef: undefined,
    headerImageAltText: undefined,
    openingHoursText: undefined,
    descriptionText: undefined,
    locationText: undefined,
    mapPdfRef: undefined,
    defaultMapZoomFrame: undefined,
    mapAltText: undefined,
    location: undefined,
    wayfindingMapRef: undefined,
    extendedDescriptionText: undefined,
    iconImageRef: undefined,
    iconSelectedImageRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["amenityCategoryRef"] = v.amenityCategoryRef;
      obj["name"] = TranslatableStringValue.codec.encode(v.name);
      obj["headerImageRef"] = v.headerImageRef;
      obj["headerImageAltText"] = TranslatableStringValue.codec.encode(v.headerImageAltText);
      obj["openingHoursText"] = TranslatableStringValue.codec.encode(v.openingHoursText);
      obj["descriptionText"] = TranslatableStringValue.codec.encode(v.descriptionText);
      obj["locationText"] = TranslatableStringValue.codec.encode(v.locationText);
      obj["mapPdfRef"] = v.mapPdfRef;
      obj["defaultMapZoomFrame"] = Rectangle.codec.encode(v.defaultMapZoomFrame);
      obj["mapAltText"] = TranslatableStringValue.codec.encode(v.mapAltText);
      obj["location"] = PlacedPoint.codec.encode(v.location);
      obj["wayfindingMapRef"] = v.wayfindingMapRef;
      obj["extendedDescriptionText"] = TranslatableStringValue.codec.encode(v.extendedDescriptionText);
      obj["iconImageRef"] = v.iconImageRef;
      obj["iconSelectedImageRef"] = v.iconSelectedImageRef;
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_management.CreateAmenityRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["amenityCategoryRef"] = v["amenityCategoryRef"];
      out["name"] = ctx.decode(TranslatableStringValue.codec, v["name"], "name");
      out["headerImageRef"] = v["headerImageRef"];
      out["headerImageAltText"] = ctx.decode(TranslatableStringValue.codec, v["headerImageAltText"], "headerImageAltText");
      out["openingHoursText"] = ctx.decode(TranslatableStringValue.codec, v["openingHoursText"], "openingHoursText");
      out["descriptionText"] = ctx.decode(TranslatableStringValue.codec, v["descriptionText"], "descriptionText");
      out["locationText"] = ctx.decode(TranslatableStringValue.codec, v["locationText"], "locationText");
      out["mapPdfRef"] = v["mapPdfRef"];
      out["defaultMapZoomFrame"] = ctx.decode(Rectangle.codec, v["defaultMapZoomFrame"], "defaultMapZoomFrame");
      out["mapAltText"] = ctx.decode(TranslatableStringValue.codec, v["mapAltText"], "mapAltText");
      out["location"] = ctx.decode(PlacedPoint.codec, v["location"], "location");
      out["wayfindingMapRef"] = v["wayfindingMapRef"];
      out["extendedDescriptionText"] = ctx.decode(TranslatableStringValue.codec, v["extendedDescriptionText"], "extendedDescriptionText");
      out["iconImageRef"] = v["iconImageRef"];
      out["iconSelectedImageRef"] = v["iconSelectedImageRef"];
      return out as any as Entity;
    }
  }();
}

export namespace CreateAmenityResponse {
  export const refName = "mos.org.getty.visitor_info_management.CreateAmenityResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly amenity: Amenity.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    amenity: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["amenity"] = Amenity.codec.encode(v.amenity);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_management.CreateAmenityResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["amenity"] = ctx.decode(Amenity.codec, v["amenity"], "amenity");
      return out as any as Entity;
    }
  }();
}

export namespace CreateVisitorInfoPageRequest {
  export const refName = "mos.org.getty.visitor_info_management.CreateVisitorInfoPageRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly siteContentRef: { readonly typename: 'mos.org.getty.visitor_info.VisitorInfoSiteContent', readonly id: string } | undefined,
    // list_title and list_icon_ref appear in the cells in the list in the Info
    // tab
    readonly listTitle: TranslatableStringValue.Entity | undefined,
    // list_icon_ref is optional
    readonly listIconRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
    readonly pageProperties: VisitorInfoPage.SectionSeparator.Entity | VisitorInfoPage.SiteMap.Entity | VisitorInfoPage.StaticWebPage.Entity | VisitorInfoPage.URLWebPage.Entity | VisitorInfoPage.AppPage.Entity | VisitorInfoPage.AmenityCategory.Entity | VisitorInfoPage.DeepDivePage.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    siteContentRef: undefined,
    listTitle: undefined,
    listIconRef: undefined,
    pageProperties: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["siteContentRef"] = v.siteContentRef;
      obj["listTitle"] = TranslatableStringValue.codec.encode(v.listTitle);
      obj["listIconRef"] = v.listIconRef;
      {
        const uv: any = v.pageProperties;
        if (uv !== undefined) {
          if (uv.type == "mos.org.getty.visitor_info.VisitorInfoPage.AmenityCategory") {
            obj["amenityCategory"] = VisitorInfoPage.AmenityCategory.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.visitor_info.VisitorInfoPage.AppPage") {
            obj["appPage"] = VisitorInfoPage.AppPage.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.visitor_info.VisitorInfoPage.DeepDivePage") {
            obj["deepDivePage"] = VisitorInfoPage.DeepDivePage.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.visitor_info.VisitorInfoPage.SectionSeparator") {
            obj["sectionSeparator"] = VisitorInfoPage.SectionSeparator.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.visitor_info.VisitorInfoPage.SiteMap") {
            obj["siteMap"] = VisitorInfoPage.SiteMap.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.visitor_info.VisitorInfoPage.StaticWebPage") {
            obj["staticWebPage"] = VisitorInfoPage.StaticWebPage.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.visitor_info.VisitorInfoPage.URLWebPage") {
            obj["urlWebPage"] = VisitorInfoPage.URLWebPage.codec.encode(uv);
          }
          else {
            throw new WebRPCError("union discrimination failed for .mos.org.getty.visitor_info_management.CreateVisitorInfoPageRequest.page_properties");
          }
        }
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_management.CreateVisitorInfoPageRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["siteContentRef"] = v["siteContentRef"];
      out["listTitle"] = ctx.decode(TranslatableStringValue.codec, v["listTitle"], "listTitle");
      out["listIconRef"] = v["listIconRef"];
      {
        if (v["amenityCategory"] !== undefined) {
          out["pageProperties"] = ctx.decode(VisitorInfoPage.AmenityCategory.codec, v["amenityCategory"], "amenityCategory");
        }
        if (v["appPage"] !== undefined) {
          out["pageProperties"] = ctx.decode(VisitorInfoPage.AppPage.codec, v["appPage"], "appPage");
        }
        if (v["deepDivePage"] !== undefined) {
          out["pageProperties"] = ctx.decode(VisitorInfoPage.DeepDivePage.codec, v["deepDivePage"], "deepDivePage");
        }
        if (v["sectionSeparator"] !== undefined) {
          out["pageProperties"] = ctx.decode(VisitorInfoPage.SectionSeparator.codec, v["sectionSeparator"], "sectionSeparator");
        }
        if (v["siteMap"] !== undefined) {
          out["pageProperties"] = ctx.decode(VisitorInfoPage.SiteMap.codec, v["siteMap"], "siteMap");
        }
        if (v["staticWebPage"] !== undefined) {
          out["pageProperties"] = ctx.decode(VisitorInfoPage.StaticWebPage.codec, v["staticWebPage"], "staticWebPage");
        }
        if (v["urlWebPage"] !== undefined) {
          out["pageProperties"] = ctx.decode(VisitorInfoPage.URLWebPage.codec, v["urlWebPage"], "urlWebPage");
        }
      }
      return out as any as Entity;
    }
  }();
}

export namespace CreateVisitorInfoPageResponse {
  export const refName = "mos.org.getty.visitor_info_management.CreateVisitorInfoPageResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly visitorInfoPage: VisitorInfoPage.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    visitorInfoPage: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["visitorInfoPage"] = VisitorInfoPage.codec.encode(v.visitorInfoPage);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_management.CreateVisitorInfoPageResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["visitorInfoPage"] = ctx.decode(VisitorInfoPage.codec, v["visitorInfoPage"], "visitorInfoPage");
      return out as any as Entity;
    }
  }();
}

export namespace CreateVisitorInfoSiteContentRequest {
  export const refName = "mos.org.getty.visitor_info_management.CreateVisitorInfoSiteContentRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly siteRef: { readonly typename: 'mos.structure.Site', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    siteRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_management.CreateVisitorInfoSiteContentRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["siteRef"] = v["siteRef"];
      return out as any as Entity;
    }
  }();
}

export namespace CreateVisitorInfoSiteContentResponse {
  export const refName = "mos.org.getty.visitor_info_management.CreateVisitorInfoSiteContentResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly visitorInfoSiteContent: VisitorInfoSiteContent.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    visitorInfoSiteContent: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      return stripTypePropertyDeep(v);
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_management.CreateVisitorInfoSiteContentResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["visitorInfoSiteContent"] = ctx.decode(VisitorInfoSiteContent.codec, v["visitorInfoSiteContent"], "visitorInfoSiteContent");
      return out as any as Entity;
    }
  }();
}

export namespace DeleteAmenityRequest {
  export const refName = "mos.org.getty.visitor_info_management.DeleteAmenityRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly amenityRef: { readonly typename: 'mos.org.getty.visitor_info.Amenity', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    amenityRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_management.DeleteAmenityRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["amenityRef"] = v["amenityRef"];
      return out as any as Entity;
    }
  }();
}

export namespace DeleteAmenityResponse {
  export const refName = "mos.org.getty.visitor_info_management.DeleteAmenityResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.visitor_info.Amenity', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_management.DeleteAmenityResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      return out as any as Entity;
    }
  }();
}

export namespace DeleteVisitorInfoPageRequest {
  export const refName = "mos.org.getty.visitor_info_management.DeleteVisitorInfoPageRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly visitorInfoPageRef: { readonly typename: 'mos.org.getty.visitor_info.VisitorInfoPage', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    visitorInfoPageRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_management.DeleteVisitorInfoPageRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["visitorInfoPageRef"] = v["visitorInfoPageRef"];
      return out as any as Entity;
    }
  }();
}

export namespace DeleteVisitorInfoPageResponse {
  export const refName = "mos.org.getty.visitor_info_management.DeleteVisitorInfoPageResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.visitor_info.VisitorInfoPage', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_management.DeleteVisitorInfoPageResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      return out as any as Entity;
    }
  }();
}

export namespace DeleteVisitorInfoSiteContentRequest {
  export const refName = "mos.org.getty.visitor_info_management.DeleteVisitorInfoSiteContentRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly visitorInfoSiteContentRef: { readonly typename: 'mos.org.getty.visitor_info.VisitorInfoSiteContent', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    visitorInfoSiteContentRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_management.DeleteVisitorInfoSiteContentRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["visitorInfoSiteContentRef"] = v["visitorInfoSiteContentRef"];
      return out as any as Entity;
    }
  }();
}

export namespace DeleteVisitorInfoSiteContentResponse {
  export const refName = "mos.org.getty.visitor_info_management.DeleteVisitorInfoSiteContentResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.visitor_info.VisitorInfoSiteContent', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_management.DeleteVisitorInfoSiteContentResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      return out as any as Entity;
    }
  }();
}

export namespace UpdateAmenityRequest {
  export type Ref = { readonly typename: 'mos.org.getty.visitor_info.Amenity', readonly id: string };
  export function isRef(v: { typename: string, id: string } | undefined): v is Ref {
    return !!v && typeof v.id === "string" && (v.typename === 'mos.org.getty.visitor_info.Amenity');
  }
  export function mustRef(v: { typename: string, id: string } | undefined): Ref {
    if (!isRef(v)) throw new WebRPCError(`Ref ${v && v.typename}:${v && v.id} is not a valid ref for a UpdateAmenityRequest`);
    return v;
  }
  export const refName = "mos.org.getty.visitor_info_management.UpdateAmenityRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.visitor_info.Amenity', readonly id: string } | undefined,
    readonly updateMask: FieldMask<"ref" | "amenityCategoryRef" | "name" | "headerImageRef" | "headerImageAltText" | "openingHoursText" | "descriptionText" | "locationText" | "mapPdfRef" | "defaultMapZoomFrame" | "mapAltText" | "location" | "wayfindingMapRef" | "extendedDescriptionText" | "iconImageRef" | "iconSelectedImageRef">,
    readonly amenityCategoryRef: { readonly typename: 'mos.org.getty.visitor_info.VisitorInfoPage', readonly id: string } | undefined,
    readonly name: TranslatableStringValue.Entity | undefined,
    readonly headerImageRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
    readonly headerImageAltText: TranslatableStringValue.Entity | undefined,
    readonly openingHoursText: TranslatableStringValue.Entity | undefined,
    readonly descriptionText: TranslatableStringValue.Entity | undefined,
    readonly locationText: TranslatableStringValue.Entity | undefined,
    readonly mapPdfRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
    readonly defaultMapZoomFrame: Rectangle.Entity | undefined,
    readonly mapAltText: TranslatableStringValue.Entity | undefined,
    readonly location: PlacedPoint.Entity | undefined,
    readonly wayfindingMapRef: { readonly typename: 'mos.org.getty.audio.WayfindingMap', readonly id: string } | undefined,
    readonly extendedDescriptionText: TranslatableStringValue.Entity | undefined,
    readonly iconImageRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
    readonly iconSelectedImageRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
    updateMask: { type: "google.protobuf.FieldMask", fields: [] },
    amenityCategoryRef: undefined,
    name: undefined,
    headerImageRef: undefined,
    headerImageAltText: undefined,
    openingHoursText: undefined,
    descriptionText: undefined,
    locationText: undefined,
    mapPdfRef: undefined,
    defaultMapZoomFrame: undefined,
    mapAltText: undefined,
    location: undefined,
    wayfindingMapRef: undefined,
    extendedDescriptionText: undefined,
    iconImageRef: undefined,
    iconSelectedImageRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["ref"] = v.ref;
      obj["updateMask"] = v.updateMask.fields.join(",");
      obj["amenityCategoryRef"] = v.amenityCategoryRef;
      obj["name"] = TranslatableStringValue.codec.encode(v.name);
      obj["headerImageRef"] = v.headerImageRef;
      obj["headerImageAltText"] = TranslatableStringValue.codec.encode(v.headerImageAltText);
      obj["openingHoursText"] = TranslatableStringValue.codec.encode(v.openingHoursText);
      obj["descriptionText"] = TranslatableStringValue.codec.encode(v.descriptionText);
      obj["locationText"] = TranslatableStringValue.codec.encode(v.locationText);
      obj["mapPdfRef"] = v.mapPdfRef;
      obj["defaultMapZoomFrame"] = Rectangle.codec.encode(v.defaultMapZoomFrame);
      obj["mapAltText"] = TranslatableStringValue.codec.encode(v.mapAltText);
      obj["location"] = PlacedPoint.codec.encode(v.location);
      obj["wayfindingMapRef"] = v.wayfindingMapRef;
      obj["extendedDescriptionText"] = TranslatableStringValue.codec.encode(v.extendedDescriptionText);
      obj["iconImageRef"] = v.iconImageRef;
      obj["iconSelectedImageRef"] = v.iconSelectedImageRef;
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_management.UpdateAmenityRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      {
        const fmvs = ensureScalar(ctx, v["updateMask"], "string").split(/\s,\s/);
        for (const fmv of fmvs) {
          if (fmv !== "ref" && fmv !== "amenityCategoryRef" && fmv !== "name" && fmv !== "headerImageRef" && fmv !== "headerImageAltText" && fmv !== "openingHoursText" && fmv !== "descriptionText" && fmv !== "locationText" && fmv !== "mapPdfRef" && fmv !== "defaultMapZoomFrame" && fmv !== "mapAltText" && fmv !== "location" && fmv !== "wayfindingMapRef" && fmv !== "extendedDescriptionText" && fmv !== "iconImageRef" && fmv !== "iconSelectedImageRef") {
            throw ctx.error(`received invalid value ${fmv} in field mask`);
          }
        }
        out["updateMask"] = fmvs;
      }
      out["amenityCategoryRef"] = v["amenityCategoryRef"];
      out["name"] = ctx.decode(TranslatableStringValue.codec, v["name"], "name");
      out["headerImageRef"] = v["headerImageRef"];
      out["headerImageAltText"] = ctx.decode(TranslatableStringValue.codec, v["headerImageAltText"], "headerImageAltText");
      out["openingHoursText"] = ctx.decode(TranslatableStringValue.codec, v["openingHoursText"], "openingHoursText");
      out["descriptionText"] = ctx.decode(TranslatableStringValue.codec, v["descriptionText"], "descriptionText");
      out["locationText"] = ctx.decode(TranslatableStringValue.codec, v["locationText"], "locationText");
      out["mapPdfRef"] = v["mapPdfRef"];
      out["defaultMapZoomFrame"] = ctx.decode(Rectangle.codec, v["defaultMapZoomFrame"], "defaultMapZoomFrame");
      out["mapAltText"] = ctx.decode(TranslatableStringValue.codec, v["mapAltText"], "mapAltText");
      out["location"] = ctx.decode(PlacedPoint.codec, v["location"], "location");
      out["wayfindingMapRef"] = v["wayfindingMapRef"];
      out["extendedDescriptionText"] = ctx.decode(TranslatableStringValue.codec, v["extendedDescriptionText"], "extendedDescriptionText");
      out["iconImageRef"] = v["iconImageRef"];
      out["iconSelectedImageRef"] = v["iconSelectedImageRef"];
      return out as any as Entity;
    }
  }();
}

export namespace UpdateAmenityResponse {
  export const refName = "mos.org.getty.visitor_info_management.UpdateAmenityResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly amenity: Amenity.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    amenity: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["amenity"] = Amenity.codec.encode(v.amenity);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_management.UpdateAmenityResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["amenity"] = ctx.decode(Amenity.codec, v["amenity"], "amenity");
      return out as any as Entity;
    }
  }();
}

export namespace UpdateVisitorInfoPageRequest {
  export type Ref = { readonly typename: 'mos.org.getty.visitor_info.VisitorInfoPage', readonly id: string };
  export function isRef(v: { typename: string, id: string } | undefined): v is Ref {
    return !!v && typeof v.id === "string" && (v.typename === 'mos.org.getty.visitor_info.VisitorInfoPage');
  }
  export function mustRef(v: { typename: string, id: string } | undefined): Ref {
    if (!isRef(v)) throw new WebRPCError(`Ref ${v && v.typename}:${v && v.id} is not a valid ref for a UpdateVisitorInfoPageRequest`);
    return v;
  }
  export const refName = "mos.org.getty.visitor_info_management.UpdateVisitorInfoPageRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly visitorInfoPageRef: { readonly typename: 'mos.org.getty.visitor_info.VisitorInfoPage', readonly id: string } | undefined,
    readonly updateMask: FieldMask<"visitorInfoPageRef" | "listTitle" | "listIconRef" | "sectionSeparator" | "siteMap" | "staticWebPage" | "urlWebPage" | "appPage" | "amenityCategory" | "deepDivePage">,
    // list_title and list_icon_ref appear in the cells in the list in the Info
    // tab
    readonly listTitle: TranslatableStringValue.Entity | undefined,
    // list_icon_ref is optional
    readonly listIconRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
    readonly pageProperties: VisitorInfoPage.SectionSeparator.Entity | VisitorInfoPage.SiteMap.Entity | VisitorInfoPage.StaticWebPage.Entity | VisitorInfoPage.URLWebPage.Entity | VisitorInfoPage.AppPage.Entity | VisitorInfoPage.AmenityCategory.Entity | VisitorInfoPage.DeepDivePage.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    visitorInfoPageRef: undefined,
    updateMask: { type: "google.protobuf.FieldMask", fields: [] },
    listTitle: undefined,
    listIconRef: undefined,
    pageProperties: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["visitorInfoPageRef"] = v.visitorInfoPageRef;
      obj["updateMask"] = v.updateMask.fields.join(",");
      obj["listTitle"] = TranslatableStringValue.codec.encode(v.listTitle);
      obj["listIconRef"] = v.listIconRef;
      {
        const uv: any = v.pageProperties;
        if (uv !== undefined) {
          if (uv.type == "mos.org.getty.visitor_info.VisitorInfoPage.AmenityCategory") {
            obj["amenityCategory"] = VisitorInfoPage.AmenityCategory.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.visitor_info.VisitorInfoPage.AppPage") {
            obj["appPage"] = VisitorInfoPage.AppPage.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.visitor_info.VisitorInfoPage.DeepDivePage") {
            obj["deepDivePage"] = VisitorInfoPage.DeepDivePage.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.visitor_info.VisitorInfoPage.SectionSeparator") {
            obj["sectionSeparator"] = VisitorInfoPage.SectionSeparator.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.visitor_info.VisitorInfoPage.SiteMap") {
            obj["siteMap"] = VisitorInfoPage.SiteMap.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.visitor_info.VisitorInfoPage.StaticWebPage") {
            obj["staticWebPage"] = VisitorInfoPage.StaticWebPage.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.visitor_info.VisitorInfoPage.URLWebPage") {
            obj["urlWebPage"] = VisitorInfoPage.URLWebPage.codec.encode(uv);
          }
          else {
            throw new WebRPCError("union discrimination failed for .mos.org.getty.visitor_info_management.UpdateVisitorInfoPageRequest.page_properties");
          }
        }
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_management.UpdateVisitorInfoPageRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["visitorInfoPageRef"] = v["visitorInfoPageRef"];
      {
        const fmvs = ensureScalar(ctx, v["updateMask"], "string").split(/\s,\s/);
        for (const fmv of fmvs) {
          if (fmv !== "visitorInfoPageRef" && fmv !== "listTitle" && fmv !== "listIconRef" && fmv !== "sectionSeparator" && fmv !== "siteMap" && fmv !== "staticWebPage" && fmv !== "urlWebPage" && fmv !== "appPage" && fmv !== "amenityCategory" && fmv !== "deepDivePage") {
            throw ctx.error(`received invalid value ${fmv} in field mask`);
          }
        }
        out["updateMask"] = fmvs;
      }
      out["listTitle"] = ctx.decode(TranslatableStringValue.codec, v["listTitle"], "listTitle");
      out["listIconRef"] = v["listIconRef"];
      {
        if (v["amenityCategory"] !== undefined) {
          out["pageProperties"] = ctx.decode(VisitorInfoPage.AmenityCategory.codec, v["amenityCategory"], "amenityCategory");
        }
        if (v["appPage"] !== undefined) {
          out["pageProperties"] = ctx.decode(VisitorInfoPage.AppPage.codec, v["appPage"], "appPage");
        }
        if (v["deepDivePage"] !== undefined) {
          out["pageProperties"] = ctx.decode(VisitorInfoPage.DeepDivePage.codec, v["deepDivePage"], "deepDivePage");
        }
        if (v["sectionSeparator"] !== undefined) {
          out["pageProperties"] = ctx.decode(VisitorInfoPage.SectionSeparator.codec, v["sectionSeparator"], "sectionSeparator");
        }
        if (v["siteMap"] !== undefined) {
          out["pageProperties"] = ctx.decode(VisitorInfoPage.SiteMap.codec, v["siteMap"], "siteMap");
        }
        if (v["staticWebPage"] !== undefined) {
          out["pageProperties"] = ctx.decode(VisitorInfoPage.StaticWebPage.codec, v["staticWebPage"], "staticWebPage");
        }
        if (v["urlWebPage"] !== undefined) {
          out["pageProperties"] = ctx.decode(VisitorInfoPage.URLWebPage.codec, v["urlWebPage"], "urlWebPage");
        }
      }
      return out as any as Entity;
    }
  }();
}

export namespace UpdateVisitorInfoPageResponse {
  export const refName = "mos.org.getty.visitor_info_management.UpdateVisitorInfoPageResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly visitorInfoPage: VisitorInfoPage.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    visitorInfoPage: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["visitorInfoPage"] = VisitorInfoPage.codec.encode(v.visitorInfoPage);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_management.UpdateVisitorInfoPageResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["visitorInfoPage"] = ctx.decode(VisitorInfoPage.codec, v["visitorInfoPage"], "visitorInfoPage");
      return out as any as Entity;
    }
  }();
}

export namespace UpdateVisitorInfoSiteContentRequest {
  export type Ref = { readonly typename: 'mos.org.getty.visitor_info.VisitorInfoSiteContent', readonly id: string };
  export function isRef(v: { typename: string, id: string } | undefined): v is Ref {
    return !!v && typeof v.id === "string" && (v.typename === 'mos.org.getty.visitor_info.VisitorInfoSiteContent');
  }
  export function mustRef(v: { typename: string, id: string } | undefined): Ref {
    if (!isRef(v)) throw new WebRPCError(`Ref ${v && v.typename}:${v && v.id} is not a valid ref for a UpdateVisitorInfoSiteContentRequest`);
    return v;
  }
  export const refName = "mos.org.getty.visitor_info_management.UpdateVisitorInfoSiteContentRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly visitorInfoSiteContentRef: { readonly typename: 'mos.org.getty.visitor_info.VisitorInfoSiteContent', readonly id: string } | undefined,
    readonly updateMask: FieldMask<"visitorInfoSiteContentRef" | "visitorInfoPageRefs">,
    readonly visitorInfoPageRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.visitor_info.VisitorInfoPage', readonly id: string }>,
  }
  export const defaults: Entity = {
    type: refName,
    visitorInfoSiteContentRef: undefined,
    updateMask: { type: "google.protobuf.FieldMask", fields: [] },
    visitorInfoPageRefs: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["visitorInfoSiteContentRef"] = v.visitorInfoSiteContentRef;
      obj["updateMask"] = v.updateMask.fields.join(",");
      obj["visitorInfoPageRefs"] = v.visitorInfoPageRefs;
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_management.UpdateVisitorInfoSiteContentRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["visitorInfoSiteContentRef"] = v["visitorInfoSiteContentRef"];
      {
        const fmvs = ensureScalar(ctx, v["updateMask"], "string").split(/\s,\s/);
        for (const fmv of fmvs) {
          if (fmv !== "visitorInfoSiteContentRef" && fmv !== "visitorInfoPageRefs") {
            throw ctx.error(`received invalid value ${fmv} in field mask`);
          }
        }
        out["updateMask"] = fmvs;
      }
      out["visitorInfoPageRefs"] = v["visitorInfoPageRefs"];
      return out as any as Entity;
    }
  }();
}

export namespace UpdateVisitorInfoSiteContentResponse {
  export const refName = "mos.org.getty.visitor_info_management.UpdateVisitorInfoSiteContentResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly visitorInfoSiteContent: VisitorInfoSiteContent.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    visitorInfoSiteContent: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      return stripTypePropertyDeep(v);
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_management.UpdateVisitorInfoSiteContentResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["visitorInfoSiteContent"] = ctx.decode(VisitorInfoSiteContent.codec, v["visitorInfoSiteContent"], "visitorInfoSiteContent");
      return out as any as Entity;
    }
  }();
}

